import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { SubscriptionPlanRecapComponent } from '~app/app/subscription/components/subscription-plan-recap/subscription-plan-recap.component';
import { BaseComponent } from '~app/app/~shared/abstract-components/base.component';

@Component({
  selector: 'competing-time-slots-creation-dialog',
  standalone: true,
  imports: [],
  templateUrl: './competing-time-slots-creation-dialog.component.html',
  styleUrl: './competing-time-slots-creation-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CompetingTimeSlotsCreationDialogComponent extends BaseComponent {
  protected _dialogRef = inject(MatDialogRef<SubscriptionPlanRecapComponent>);
  close(): void {
    this._dialogRef.close();
  }
}
